import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LoggedInCallback} from "../../service-auth/cognito.service";
import {Router} from "@angular/router";
import {StartupService} from "../../service-ui/startup.service";
import {Order} from "../../../model/Order";
import {OrderService} from "../../service-data/order.service";
import { MatSidenav } from "@angular/material/sidenav";
import {MediaMatcher} from "@angular/cdk/layout";
import {Subject} from "rxjs";

@Component({
  selector: 'app-orders-delete',
  templateUrl: './orders-delete.component.html',
  styleUrls: ['./orders-delete.component.css']
})

export class OrdersDeleteComponent implements OnDestroy, OnInit, LoggedInCallback {
  @ViewChild('mainSideNav', { static: true }) mainSideNav: MatSidenav;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  selectedOrder: Order;
  orders: Order[];

  constructor(public router: Router, public startupService: StartupService, private orderService: OrderService, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher) {
    this.startupService.touchLastUserActivity();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }


  ngOnInit() {
    this.startupService.isAuthenticated(this);
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/login']);
    } else {
      this.getOrders();
    }
  }

  onSelect(order: Order): void {
    this.selectedOrder = order;
  }

  getOrders(): void {
    this.startupService.touchLastUserActivity();
    this.orderService.getOrders()
      .subscribe(orders => {
        this.orders = orders;
      });
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
  }
}
